module.exports = __webpack_public_path__ + "img/sashimivogelpersektive.83aae271.jpg";